// Chrome 60-safe helpers shared by the layout components (no ?. / ??).

// Wall-clock arrival time, e.g. "4:42 PM". Built by hand rather than with
// toLocaleTimeString so old Chromium builds with a trimmed-down ICU still
// render a 12-hour clock instead of falling back to a 24-hour one.
export const formatArrival = function (secs) {
  if (secs == null) return "";
  var n = Number(secs);
  if (!isFinite(n) || n < 0) return "";
  var t = new Date(new Date().getTime() + n * 1000);
  var h = t.getHours();
  var m = t.getMinutes();
  var ampm = h >= 12 ? "PM" : "AM";
  var hh = h % 12;
  if (hh === 0) hh = 12;
  return hh + ":" + (m < 10 ? "0" + m : m) + " " + ampm;
};

// "in 24 mins." -> "24 mins" — the data-only views label the number
// themselves, so the sentence wrapper gets in the way.
export const bareDuration = function (text) {
  if (!text) return "";
  return String(text).replace(/^in\s+/i, "").replace(/\.\s*$/, "");
};

// Pickup name for the From row of the journey rail.
export const pickupLabel = function (pickup) {
  if (!pickup) return "";
  if (pickup.customName) return pickup.customName;
  var addr = (pickup.location && pickup.location.address) || "";
  return addr.split(",").slice(0, 2).join(",").trim();
};
